import { render, staticRenderFns } from "./Tai.vue?vue&type=template&id=100274c4&scoped=true&"
import script from "./Tai.vue?vue&type=script&lang=js&"
export * from "./Tai.vue?vue&type=script&lang=js&"
import style0 from "./Tai.vue?vue&type=style&index=0&id=100274c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100274c4",
  null
  
)

export default component.exports